import { createContext, ReactNode, useMemo } from 'react';
import { usePermissions } from '../hooks/use-permissions';
import { PermissionAlias } from '../utils/enums';

interface PermissionContext {
  list: PermissionAlias[];
  hasIndividualPermissions: boolean;
  getPermissions: () => void;
}

export const PermissionContext = createContext<PermissionContext>({
  list: [],
  hasIndividualPermissions: false,
  getPermissions: () => {},
});

const PermissionProvider = ({ children }: { children: ReactNode }) => {
  const { getPermissions, permissions, hasIndividualPermissions } =
    usePermissions();

  const value = useMemo(
    () => ({ list: permissions, hasIndividualPermissions, getPermissions }),
    [permissions, hasIndividualPermissions, getPermissions],
  );

  return (
    <PermissionContext.Provider value={value}>
      {children}
    </PermissionContext.Provider>
  );
};

export default PermissionProvider;
